import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';
import { getTranslationKeyByShippingTime } from '../../../../../_modules/shipping/translationKey/get_translation_key_by_shipping_time';
import Countdown from 'react-countdown';
import {getShippingEta} from "../../../../../_modules/shipping/eta/get_shipping_eta";

const FooterActions = ({ shippingTime, onSelectStationClick, deactivatedInFsf, deactivatedInFsfFrom, deactivatedInFsfUntil, isMarketplaceSeller, mpsDoesSameDayFitting, mpsDoesSameDayFittingCutoff, productStock, etaFrom, etaTo }) => {
    const classSwitcher = (deactivatedInFsf)?
        'fsf-station__detail-actions actions-with-closure fsf-station__section':
        'fsf-station__detail-actions fsf-station__section';
    const isMpsProduct = productStock !== null && true === productStock.isMpsProduct;

    let untilParts = (deactivatedInFsf) ?
        deactivatedInFsfUntil.split('-') : '';
    let until = (3 === untilParts.length)?
        untilParts[2] + '/' + untilParts[1] + '/' + untilParts[0]:
        '';
    const showFittingDelayMessage = (deactivatedInFsf)?
        <Translation translationKey="fitting-station-fitting-delay-message"
                     placeholder={{ UNTIL: until}}
        />:
        '';

    const CountdownComplete = () => <Translation
                translationKey="fitting-station-finder-overview-order-today-fitted-tomorrow"
            />;

    let dateObj = new Date();
    dateObj.setHours(23, 59, 0, 0);
    if (isMarketplaceSeller && isMpsProduct) {
        if (mpsDoesSameDayFittingCutoff.length === 5) {
            let mpsCutoffTimeParts = mpsDoesSameDayFittingCutoff.split(':');
            dateObj.setHours(mpsCutoffTimeParts[0], mpsCutoffTimeParts[1], 0, 0);
        }
    }

    const countdownExpressOrderRenderer = ({hours, minutes, seconds, completed}) => {
        if (completed) {
            // Render a completed state
            return <CountdownComplete />
        } else {
            // Render a countdown
            return <Translation
                        className="fsf-station-overview__express-order-label"
                        translationKey="fitting-station-finder-overview-express-order-within"
                        placeholder={{ countdownExpressHours: hours, countdownExpressMinutes: minutes}}
                    />
        }
    };

    const countdownOrderNowFitTomorrowRenderer = ({hours, minutes, seconds, completed}) => {
        if (completed) {
            // Render a completed state
            return <CountdownComplete />
        } else {
            // Render a countdown
            return <Translation
                        translationKey="fitting-station-finder-overview-order-within-today-fitted-tomorrow"
                        placeholder={{ countdownCutoffHours: hours, countdownCutoffMinutes: minutes}}
                    />
        }
    };

    function renderFooterMessage() {
        if (deactivatedInFsf) {
            return <Translation
                translationKey="fitting-station-shipping-delay-message"
                placeholder={{ UNTIL: until }}
            />;
        }

        if (isMarketplaceSeller && isMpsProduct && mpsDoesSameDayFitting) {
            return <Countdown
                date={dateObj.getTime()}
                renderer={countdownExpressOrderRenderer}
                zeroPadTime={2}
                zeroPadDays={2}
            />
        } else if (isMarketplaceSeller && isMpsProduct && !mpsDoesSameDayFitting) {
            return <Countdown
                date={dateObj.getTime()}
                renderer={countdownOrderNowFitTomorrowRenderer}
                zeroPadTime={2}
                zeroPadDays={2}
            />
        }

        return getShippingEta(etaFrom, etaTo);
    }


    return (
        <div className={classSwitcher}>
            <div className="fsf-station__select-fitting-station-container">
                {showFittingDelayMessage}
                <button
                    className="fsf-station__action fsf-station__select-fitting-station"
                    onClick={onSelectStationClick}
                >
                    <Translation translationKey="fitting-station-finder-app-save-station" />
                </button>
            </div>

            <div className="fsf-station__detail-totals">
                <p className="fsf-station__delivery-time">
                    {renderFooterMessage()}
                </p>
            </div>
        </div>
    );
};

FooterActions.propTypes = {
    shippingTime: PropTypes.string.isRequired,
    onSelectStationClick: PropTypes.func.isRequired,
    deactivatedInFsf: PropTypes.bool,
    deactivatedInFsfFrom: PropTypes.string,
    deactivatedInFsfUntil: PropTypes.string,
    isMarketplaceSeller: PropTypes.bool,
    mpsDoesSameDayFitting: PropTypes.bool,
    mpsDoesSameDayFittingCutoff: PropTypes.string,
    productStock: PropTypes.object,
    etaFrom: PropTypes.object,
    etaTo: PropTypes.object,
};

FooterActions.defaultProps = {
    isMarketplaceSeller: false,
    mpsDoesSameDayFitting: false,
    productStock: null,
    etaFrom: null,
    etaTo: null,
};

export default FooterActions;
